import { createSelector } from 'reselect';

const contentSelector = state => state.content;

export const current = createSelector(contentSelector, state => state.current);
export const count = createSelector(contentSelector, state => state.count);
export const query = createSelector(contentSelector, state => state.query);
export const newsItems = createSelector(contentSelector, state => state.newsItems);
export const authors = createSelector(contentSelector, state => state.authors);
export const categories = createSelector(contentSelector, state => state.categories);
export const sites = createSelector(contentSelector, state => state.sites);
export const page = createSelector(contentSelector, state => state.page);
export const offset = createSelector(contentSelector, state => state.offset);
export const resultsPageCount = createSelector(contentSelector, state => state.resultsPageCount);
export const resultsItemCount = createSelector(contentSelector, state => state.resultsItemCount);
export const post = createSelector(contentSelector, state => state.post);
